module.exports = {"question_title":"Select your security question","answer_title":"Answer","answer_placeholder":"Type your answer","questions":["Is it an example question?","Is it another example question?"]}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/securityQuestion.json
// module id = 544
// module chunks = 245 956